<template>
  <OmtLayoutContainer :minHeight="['initial', 'calc(100vh - 80px)']" :alignContent="['', 'flex-start']">
    <OmtRow mb="24px">
      <LineStepper :currentStep="1" :totalSteps="2" />
    </OmtRow>

    <OmtRow>
      <ExamesSearch
        @search="handleSearch"
        title="Buscar exames"
        :initialValue="searchQuery"
        text="Serão exibidos os exames e seus <b>detalhes</b> em relação a cobertura."
        placeholder="Busque pelo nome do exame"
      />
    </OmtRow>
    <OmtRow v-for="(exam, index) in searchExams" :key="index">
      <OmtCard mb="16px" p="12px 16px">
        <CFlex>
          <CoverageAnalysesResult :name="exam.Descricao" :result="getResult(exam)" />
          <OmtIcons :name="exam.selected ? 'minus' : 'plus'" size="lg" @click="toggleItem(exam)" cursor="pointer" />
        </CFlex>
      </OmtCard>
    </OmtRow>
    <FixedButtonRow>
      <ButtonCounter
        :w="['100%', '308px !important']"
        :count="selectedExams.length"
        :disabled="!selectedExams.length"
        @click="next()"
        label="Ver exames"
        fontSize="20px"
        fontWeight="700"
      />
    </FixedButtonRow>
  </OmtLayoutContainer>
</template>

<script>
import ExamesSearch from "@/components/Organisms/ExamesSearch/ExamesSearch.vue";
import CoverageAnalysesResult from "@/components/Molecules/CoverageAnalysesResult/index.vue";
import ButtonCounter from "@/components/Molecules/ButtonCounter/index.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import LineStepper from "@/components/Atoms/LineStepper/index.vue";
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    CoverageAnalysesResult,
    FixedButtonRow,
    ButtonCounter,
    ExamesSearch,
    LineStepper
  },
  data() {
    return {
      searchQuery: ""
    };
  },
  computed: {
    ...mapState("coverageAnalysis", ["searchExams", "selectedExams", "authorized"])
  },
  methods: {
    ...mapActions("coverageAnalysis", ["fetchExams", "selectExam", "nextStep"]),
    async toggleItem(item) {
      if (!item.selected) {
        this.addItem(item);
      } else {
        this.removeItem(item);
      }
    },
    async addItem(item) {
      this.selectExam({ CodigoExame: item.CodigoExame, Descricao: item.Descricao, value: true });

      this.$toast({
        description: "Exame adicionado",
        status: "success",
        duration: 2000,
        position: "top"
      });
    },
    async removeItem(item) {
      this.selectExam({ CodigoExame: item.CodigoExame, Descricao: item.Descricao, value: false });
      this.$toast({
        description: "Exame removido",
        status: "success",
        duration: 2000,
        position: "top"
      });
    },
    next() {
      this.$router.push({ name: "analise_cobertura.exames_selecionados" });
    },
    handleSearch: debounce(async function (value) {
      if (this.searchQuery === value) return;

      this.searchQuery = value;

      this.$root.$emit("show-loading");
      await this.fetchExams({ search: value });
      this.$root.$emit("hide-loading");
    }, 1500),
    getResult(exam) {
      if (exam?.CodigoExame === "") {
        return "request";
      }

      if (exam?.ExigeAutorizacao) {
        return "authorization";
      }

      return "coverage";
    }
  },
  mounted() {
    if (!this.authorized) {
      this.$router.push({ name: "analise_cobertura.cobertura" });
      return;
    }
    this.$root.$emit("hide-loading");
  }
};
</script>
